import {
    GET_SUPERVISOR_REQUEST,
    GET_SUPERVISOR_SUCCESS,
    GET_SUPERVISOR_ERROR,

} from "../../actions/types";

  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_SUPERVISOR_REQUEST:
        return {
          loading: true,
        };
      case GET_SUPERVISOR_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SUPERVISOR_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };

      default:
        return state;
    }
  }
  